import {MapState, Spawn} from '../map/MapState';
import {GameStateName, Game} from 'src/game/Game';
import {StateCtor} from 'src/game/states/State';
import {Location} from '../map/Location';
import {ClassicGameMode} from './ClassicGameMode';
import {FFAGameMode} from './FFAGameMode';

export type GameModeName = 'classic' | 'ffa';

export type CanBuildAtFn = (map: MapState, tiles: Location[], playerIndex: number) => boolean;

export type GameState = GameStateName;

export interface GameMode {
    game: Game;
    readonly states: {[key in GameState]: StateCtor};
    readonly startState: GameState;
    readonly showBuildability: boolean;
    possibleSpawnsForPlayer(playerIndex: number): Spawn[];
    canBuildAtLocation: CanBuildAtFn;
}

export const gameModes = {
    classic: ClassicGameMode,
    ffa: FFAGameMode,
};



// WEBPACK FOOTER //
// ./src/common/modes/GameMode.ts